import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

const SIDEBAR_PIN_KEY = 'estimator_sidebar_pinned';

@Injectable({
    providedIn: 'root'
})
export class SidenavService {

    private readonly _initialPinState: boolean =
        localStorage.getItem(SIDEBAR_PIN_KEY) === 'true';

    public sideNavState$: BehaviorSubject<boolean> =
        new BehaviorSubject<boolean>(this._initialPinState);

    public shouldPinSidenavState: BehaviorSubject<boolean> =
        new BehaviorSubject<boolean>(this._initialPinState);

    constructor() {
        this.shouldPinSidenavState.subscribe(isPinned => {
            localStorage.setItem(SIDEBAR_PIN_KEY, String(isPinned));
        });
    }
}